<script setup lang="ts">
defineOptions({
  name: 'FooterComponent'
})
</script>

<template>
  <footer class="px-0 py-0 mx-0 my-0" aria-label="Kontakt und rechtliche Informationen">
    <div class="mt-high pt-16 px-12 pb-lg-16">
      <v-row align="center" justify="center">
        <v-spacer />
        <v-col cols="12" lg="3">
          <div class="d-flex justify-center align-center align-md-start">
            <img src="/logo.svg" alt="johnsenpartner. architekten" width="100%" />
          </div>
        </v-col>
        <v-col cols="12" lg="3">
          <address
            class="d-flex flex-column justify-center align-center align-md-start"
            style="font-style: normal"
          >
            <p class="mb-1">Hansastraße 9 - 42697 Solingen</p>
            <p class="mb-1 text-center">
              <a href="tel:+492126859961" class="footer-link">0212.685 99 611</a> -
              <a href="mailto:west@johnsenpartner.de" class="footer-link">west@johnsenpartner.de</a>
            </p>
          </address>
        </v-col>
        <v-col cols="12" lg="2" class="d-none d-lg-block">
          <div class="d-flex justify-center align-center align-md-start">
            <p class="mb-1">
              <NuxtLink to="/impressum" class="footer-link">Impressum</NuxtLink> -
              <NuxtLink to="/datenschutz" class="footer-link">Datenschutz</NuxtLink>
            </p>
          </div>
        </v-col>
        <v-col cols="12" lg="2">
          <div class="d-flex justify-center align-center align-md-start">
            <div>
              <p class="mb-1">
                <a
                  href="https://www.linkedin.com/in/andreas-szklarek-260747145/"
                  class="footer-link text-center"
                  target="_blank"
                  rel="noopener noreferrer"
                  >LinkedIn</a
                >
              </p>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="2">
          <div class="d-flex justify-center align-center">
            <NuxtImg
              src="/images/2bgood-esg-siegel_web.jpg"
              alt="2bgood ESG Siegel"
              width="100"
              height="100"
              class="footer-logo"
            />
          </div>
        </v-col>
        <v-col cols="12" lg="0" class="d-lg-none">
          <div class="d-flex justify-center align-center pt-8">
            <p class="text-body-1 mb-1 mr-4">
              <NuxtLink to="/impressum" class="footer-link">Impressum</NuxtLink>
            </p>
            <p class="text-body-1 mb-1">
              <NuxtLink to="/datenschutz" class="footer-link">Datenschutz</NuxtLink>
            </p>
          </div>
        </v-col>
        <v-spacer />
      </v-row>
    </div>
  </footer>
</template>

<style scoped lang="scss">
.footer-link {
  color: black;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    text-decoration-color: #c10050;
    text-underline-offset: 0.2rem;
    text-decoration-thickness: 0.1rem;
  }

  &:focus-visible {
    text-decoration: underline;
    text-decoration-color: #c10050;
    text-underline-offset: 0.2rem;
    text-decoration-thickness: 0.1rem;
  }
}
</style>
